import type { FC} from 'react';
import { memo } from 'react';

import { AddSmall } from '@shared/assets';

import * as st from './ButtonAdd.module.scss';

interface Props {
	handler: () => void;
}

const ButtonAdd: FC<Props> = ({ handler }) => {
	return (
		<button className={st.button} onClick={handler} type="button">
			<AddSmall />
		</button>
	);
};

export default memo(ButtonAdd);
